// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.pageName : array                           ( 傳進來的分頁名字 )
// ------------------------------------


import React, { useState, useEffect} from 'react'
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ConfigHandler from '../../actions/ConfigHandler';
// import { SET_PAGE, SET_PAGENAME } from '../../stores/reducer_HistoryPage';
import { SET_ADDPAGE } from '../../stores/reducer_LayoutPage';
import { CTXHide } from '../Layout';

export const AddNavBar =(props)=>{
    const {t} = useTranslation()
    const dispatch = useDispatch()
    // useEffect(()=>{
    //     dispatch(SET_PAGENAME({pageNameList:props.pageName, index:0}))
    // }, [])
    const curAddPage = useSelector(state=>state.store_layout.currAddPage)
    const addControl = ConfigHandler.addControl().layoutArr
    const ctx_hide = useContext(CTXHide)

    return(
        <div className="h-15 fx-d-r font-m">
            <div className="w-40 fx-d-c fx-ccc">
                <div className="w-70 font-xl fx-fsc">{t(addControl[curAddPage][1])}</div>
            </div>
            {/* <div className='w-30'></div> */}
            {/* 填充空間用 */}
            {/* {props.isShow.map((isShow, index) => isShow?null:<div className="fx-2" key={index}></div>)} */}
            {/* 填充空間用 */}
            <div className='w-10'></div>
            {addControl.map((arr, index)=>(!arr[2])?<div className="w-10" key={index}></div>:
                <div key={arr} 
                    className={`fx-ccc his-option ${curAddPage===index? "activate":""}  ${arr[2]?'':'d-none'}`}
                    onClick={()=>{dispatch(SET_ADDPAGE(index))}}>
                    <img className='img_crisp' src={arr[0]} alt={arr[1]}/>
                    {t(arr[1])}
                </div>)
            }
            {/* close btn */}
            <div className="fx-2 fx-nfen" onClick={ctx_hide}>
                <div className="cross dark fx-ccc cursor pt"></div>
            </div>
            {/* close btn */}
        </div>
    );	

}